import BaseLogger from "./BaseLogger";

export default class EmptyLogger extends BaseLogger {}
